interface TransitionMessageProps {
  label?: string | null;
}

export function TransitionMessage({ label }: TransitionMessageProps) {
  return (
    <div className="flex items-center gap-4 px-4 mt-6 w-full">
      <hr className="flex-1 border-t border-secondary" />
      {label && <span className="text-secondary text-caption shrink-0">{label}</span>}
      <hr className="flex-1 border-t border-secondary" />
    </div>
  );
}
